import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ImplementerSnapshotSummary } from '../../../../models/implementer/implementer.models';
import { ImplementerService } from '../../../../services/implementer/implementer.service';
import { NavHelperService } from '../../../../services/nav/nav-helper.service';
import { NavController, ToastController } from 'ionic-angular';
import { NavMainMenuPage } from '../../../nav/nav-menus/nav-main-menu/nav-main-menu';
import { DefaultPage } from '../../../default/default-page/default-page';
import { PageArgs } from '../../../../models/projects/operation.models';
import { AppConfig } from '../../../../app/app.config';
import { DateTime } from 'luxon';
import { ValidationResultModel } from '../../../../_foundation/models/validation.models';

declare var $: any;
@Component({
  selector: 'implementer-merge-wizard-step-three',
  templateUrl: 'implementer-merge-wizard-step-three.html'
})
export class ImplementerMergeWizardStepThreeComponent {
  @Input() snapshotSummary: ImplementerSnapshotSummary;

  @Output()
  public previousStepClick: EventEmitter<void> = new EventEmitter();

  config = AppConfig.settings;

  text: string;
  loading: boolean;
  stepInitialLoadComplete: boolean = false;
  mergeComplete: boolean = false;
  mergeTimeStart: DateTime;
  validationResult: ValidationResultModel;

  private proxy: any;

  implementerLoadingText: string;
  implementerInitialiserValid: boolean;
  initialiserTimeStart: DateTime;

  constructor(
    public navCtrl: NavController,
    private implementerService: ImplementerService,
    private navHelperService: NavHelperService,
    private toastCtrl: ToastController,
  ) {

  }

  async stepInitialLoad() {
    this.stepInitialLoadComplete = false;
    await this.startConnection();
    // disables the finalise button for 2 seconds so user doesn't accidentally press it
    setTimeout(() => {
      this.stepInitialLoadComplete = true;
    }, 2000);
  }

  async completeMerge() {
    this.loading = true;
    this.validationResult = null;
    this.mergeTimeStart = DateTime.local();
    try {
      await this.implementerService.mergeImplementerChanges(this.config.isVesselEnvironment);
    } catch (error) {
      this.loading = false;
      this.validationResult = this.implementerService.buildFailureValidationResult(
        error,
        'An error occurred while merging implementer changes. Please try again. If the error persists, contact support.'
      );
      return;
    }

    // if api call returns faster than 3 seconds, setTimeout to wait until 3 seconds, minus what the api call took
    // so the user can actually see what's happening and it doesn't just flash up and disappear
    if ((DateTime.local().toMillis() - this.mergeTimeStart.toMillis()) / 1000 < 3) {
      setTimeout(() => {
        this.loading = false;
        this.mergeComplete = true;
        this.goToDefault();
      }, 3000 - (DateTime.local().toMillis() - this.mergeTimeStart.toMillis()));
    } else {
      this.loading = false;
      this.mergeComplete = true;
      this.goToDefault();
    }
  }

  goToDefault() {
    this.presentSaveToast().then(() => {
      const navPage = new PageArgs();
      navPage.page = DefaultPage;

      this.navHelperService.updateNavPage(navPage);
      this.navCtrl.setRoot(navPage.page);
      this.navHelperService.updateNavMenuPage({page: NavMainMenuPage});
    });
  }

  goBackClick() {
    this.previousStepClick.emit();
  }

  presentSaveToast(): Promise<any> {
    const toast = this.toastCtrl.create({
      message: 'Merge Success',
      duration: 3000,
      position: 'bottom'
    });

    return toast.present();
  }

  private async startConnection() {
    this.proxy = $.connection.ImplementerHub;

    this.proxy.client.BroadcastBackingUpDataMessage = ((name, message) => {
      this.implementerLoadingText = message;
    });

    this.proxy.client.BroadcastMergingDataMessage = ((name, message) => {
      this.implementerLoadingText = message;
    });

    this.proxy.client.BroadcastSavingDataMessage = ((name, message) => {
      this.implementerLoadingText = message;
      this.mergeTimeStart = DateTime.local(); // refresh timer so last message doesn't just flash up before user can read it
    });

    $.connection.hub.url = `${AppConfig.settings.apiUrl}api/signalr`;
    $.connection.hub.start({skipNegotiation: true, transport: 'serverSentEvents'})
      .done(() => {
      }).fail(err => {
      console.log(err);
    });
  }

  private stopSignalRConnection() {
    $.connection.hub.stop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/implementer/implementer-merge/implementer-merge-wizard-step-three/implementer-merge-wizard-step-three.ts